<!-- begin:: Footer -->
<div class="kt-footer kt-footer--extended kt-grid__item" id="kt_footer" style="background-image: url('./assets/media/bg/bg-2.jpg');">
	<div class="kt-footer__bottom">
		<div class="kt-container" [ngClass]="{'kt-container--fluid': fluid}">
			<div class="kt-footer__wrapper">
				<div class="kt-footer__logo">
					<a class="kt-header__brand-logo" routerLink="/">
						<img alt="Logo" src="./assets/media/logos/logo-4-sm.png" class="kt-header__brand-logo-sticky">
					</a>
					<div class="kt-footer__copyright">
						{{today | date:'yyyy'}}&nbsp;©&nbsp;
						<a href="http://www.opal-up.fr" target="_blank">Opal-UP</a>
					</div>
				</div>
				<div class="kt-footer__menu">
					<a href="#" target="_blank">CGV</a>
					<a href="#" target="_blank">Mentions légales</a>
				</div>
			</div>
		</div>
	</div>
</div>
<!-- end:: Footer -->
